import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getStats } from "../../apis/campaign";
import StatsSkeletons from "./skeletons/StatsSkeletons";
import "bootstrap-icons/font/bootstrap-icons.css";

const STAT_ITEMS = [
    { key: "campaigns", icon: "bi bi-bar-chart-fill", label: "Campaigns" },
    { key: "ideas", icon: "bi bi-lightbulb-fill", label: "Ideas" },
    { key: "posts", icon: "bi bi-file-earmark-text-fill", label: "Posts" },
];

const Stats = () => {
    const userId = useSelector((state) => state.auth.user?.uid);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        if (!userId) {
            setStats(null);
            setLoading(false);
            return () => {
                cancelled = true;
            };
        }

        async function loadStats() {
            setLoading(true);

            try {
                const data = await getStats();
                if (!cancelled) {
                    setStats(data);
                }
            } catch {
                if (!cancelled) {
                    setStats(null);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        loadStats();

        return () => {
            cancelled = true;
        };
    }, [userId]);

    if (loading) {
        return <StatsSkeletons />;
    }

    return (
        <div className="mb-5 grid grid-cols-1 gap-3 md:mb-7 md:grid-cols-3 md:gap-4">
            {STAT_ITEMS.map(({ key, icon, label }) => (
                <div
                    key={label}
                    className="stat-card surface-card relative flex min-h-[80px] items-center px-4 py-3 text-slate-900 transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] sm:min-h-[92px] md:min-h-[108px] md:px-6 md:py-5"
                >
                    <i
                        className={`${icon} stat-bg-icon absolute right-2 top-1/2 -translate-y-1/2 text-3xl text-slate-400 opacity-[0.35] md:right-5 md:text-5xl md:opacity-[0.45]`}
                        aria-hidden
                    />
                    <div className="stat-content relative z-[1] min-w-0 pr-8 md:pr-14">
                        <h3 className="text-xl font-semibold tabular-nums md:text-4xl">
                            {stats?.[key] ?? "—"}
                        </h3>
                        <p className="mt-0.5 text-sm font-medium text-slate-600 md:mt-1">
                            {label}
                        </p>
                        <p className="mt-0.5 text-xs text-slate-500">this month</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Stats;
